import { selectAppDomain, useAppSelector } from '@ibk/shared-config';
import { AppDomain } from '@ibk/shared-types';
import { useListAccountantProductCatalogQuery, useListClientProductCatalogQuery } from '../services/productsCatalogApi';
const EMPTY_PRODUCTS = [];
const VISIBLE_CATALOG_QUERY = { isVisible: true };
export function useEmissorProductCatalog() {
    const appDomain = useAppSelector(selectAppDomain);
    const isAccountant = appDomain === AppDomain.ESCRITORIO;
    const accountantQuery = useListAccountantProductCatalogQuery(VISIBLE_CATALOG_QUERY, {
        skip: !isAccountant,
    });
    const clientQuery = useListClientProductCatalogQuery(VISIBLE_CATALOG_QUERY, {
        skip: isAccountant,
    });
    const activeQuery = isAccountant ? accountantQuery : clientQuery;
    const { data, isLoading, isError } = activeQuery;
    const products = data?.products
        ? [...data.products].sort((left, right) => left.displayOrder - right.displayOrder)
        : EMPTY_PRODUCTS;
    return {
        products,
        isLoading,
        isError,
    };
}
